export default [
  {
    date: 'Aug 2018',
    name: 'Pomodoro Technique',
    url: 'https://pomodoro-technique.netlify.com/',
    repo: 'https://github.com/micheledisalvatore/pomodoro',
    description: `
      <p>A <strong>Progressive Web App (PWA)</strong> built with <strong>React and Redux</strong> and using the <strong>web push notifications</strong>.
      This project has been bootstrapped using create-react-app and it has a couple of example of <strong>unit tests</strong> written using the BDD
      methodology.</p>
    `,
  },
  {
    date: 'Aug 2018',
    name: 'FODMAP',
    url: 'https://fodmap.netlify.com/',
    repo: 'https://github.com/micheledisalvatore/fodmap',
    description: `
      <p>A <strong>Progressive Web App (PWA)</strong> built with <strong>React and Redux</strong> and using the <strong>local storage</strong> to store
      user data. This project has been bootstrapped using create-react-app and it has been released in short time (skipping then most unit tests) due to
      the necessity to follow a strict diet. But on the other side, I wrote <strong>e2e tests on Cypress</strong> in order to check the integrity of the app.
      For the styling, it is using Bootstrap with <strong>styled-components</strong>.</p>
    `,
  },
  {
    date: 'Dec 2017',
    name: 'Progress Bar',
    url: 'https://mds-react-progress-bar.netlify.com/',
    repo: 'https://github.com/micheledisalvatore/react-progress-bar',
    description: `
      <p>A simple <strong>React</strong> project written in ES6 without any state manager neither async calls. This project has been bootstrapped using
      create-react-app, it has a <strong>test coverage of 100%</strong> using <strong>Jest and Enzyme</strong>. For the styling is
      used <strong>pure CSS</strong> with the <strong>BEM methodology</strong>, using also CSS3 animations.</p>
    `,
  },
]


// WEBPACK FOOTER //
// ./src/components/Portfolio/projects.js